import { professionalTranslationFor } from './professionalTranslationRuntime.js';

const LABELS = {
  "en": "Unable to open this hospital Journey. Please check your hospital selection.",
  "fr": "Impossible d’ouvrir ce parcours. Vérifiez l’établissement sélectionné.",
  "es": "No se puede abrir este recorrido. Comprueba el hospital seleccionado.",
  "it": "Impossibile aprire questo percorso. Controlla l’ospedale selezionato.",
  "pt": "Não foi possível abrir este percurso. Verifique o hospital selecionado.",
  "ro": "Acest parcurs nu poate fi deschis. Verificați spitalul selectat.",
  "pl": "Nie można otworzyć tej ścieżki. Sprawdź wybrany szpital.",
  "tr": "Bu hastane yolculuğu açılamıyor. Hastane seçiminizi kontrol edin.",
  "ar": "تعذّر فتح هذه الرحلة العلاجية. يُرجى التحقق من اختيار المستشفى.",
  "fa": "باز کردن این مسیر بیمارستان ممکن نیست. انتخاب بیمارستان را بررسی کنید.",
  "ur": "اس ہسپتال کا سفر نہیں کھل سکا۔ منتخب ہسپتال چیک کریں۔",
  "bn": "এই হাসপাতালের যাত্রাটি খোলা যাচ্ছে না। হাসপাতাল নির্বাচন পরীক্ষা করুন।",
  "gu": "આ હોસ્પિટલની યાત્રા ખોલી શકાતી નથી. હોસ્પિટલની પસંદગી તપાસો.",
  "pa": "ਇਹ ਹਸਪਤਾਲ ਯਾਤਰਾ ਨਹੀਂ ਖੁੱਲ੍ਹ ਸਕਦੀ। ਹਸਪਤਾਲ ਦੀ ਚੋਣ ਜਾਂਚੋ।",
  "so": "Lama furi karo safarkan isbitaalka. Hubi isbitaalka aad dooratay.",
  "tl": "Hindi mabuksan ang gabay na ito. Tingnan ang napiling ospital.",
  "zh": "无法打开此医院旅程。请检查所选医院。"
};
export function savedJourneyOpenErrorCopy(language) {
  const code = String(language || 'en').toLowerCase().split('-')[0];
  return professionalTranslationFor(code, 'savedJourneyOpenError', 'message') || LABELS[code] || LABELS.en;
}
